import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dimensionFilter from '../../plugin'
import type { Plugin } from '../plugin'

/**
 * Initializes the inherited active selection from the applied snapshot.
 *
 * NOTE: `initialized$` is a one-shot stream with no replay, so this only works
 * because the storage defers its initial write by a tick while the plugin
 * manager starts effects synchronously during collection construction. If that
 * ordering ever changes, the seed silently stops happening and
 * session-persisted selections stop restoring.
 */
export const initializeSelection = store.effects.create(
  (
    _feature: Plugin['feature'],
    appliedSelectionStorage: Plugin['_appliedSelectionStorage'],
    selectionStorage: dimensionFilter.Plugin['selectionStorage'],
  ) =>
    appliedSelectionStorage.initialized$.pipe(
      rxjs.switchMap(() =>
        appliedSelectionStorage.selectors.lookup.asObservable.pipe(
          rxjs.take(1),
        ),
      ),
      rxjs.map(selectionLookup =>
        selectionStorage.actions.setLookup
          .from('DimensionFilter.CurrentList.InitializeSelection')
          .create(selectionLookup),
      ),
    ),
)
